const Contact = () => {
  return (
    <>
      <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Contact Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a className="text-white" href="">
                      Home
                    </a>
                  </li>
                  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  
                    Contact
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Get In Touch
            </h6>
            <h1 className="mb-5">We're Here to Help You</h1>
            {/* <p className="mb-5">
              Have questions about admissions, programs, or campus life? Our
              team is ready to assist you. Choose the most relevant contact
              method below.
            </p> */}
          </div>

          <div className="row g-4 mb-5">
            <div
              className="col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="contact-card">
                <div className="contact-icon">
                  <i className="fa fa-phone-alt"></i>
                </div>
                <h4 className="mb-2" style={{ color: "white" }}>
                  MCM First grade college
                </h4>
                <p className="mb-2">
                  MUDA Complex first floor Kalidasa road,opp Sony Center first
                  stage vijayanagar, Mysore-570-017
                </p>
                <p className="mb-2">
                  <i className="fa fa-phone-alt"></i> 0821-5211786
                </p>
                <p className="mb-2">
                  <i className="fa fa-envelope"></i> info@mcmcollege.com,
                </p>
              </div>
            </div>

            <div
              className="col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="contact-card">
                <div className="contact-icon">
                  <i className="fa fa-plane"></i>
                </div>
                <h4 className="mb-2" style={{ color: "white" }}>
                  Contact details for International Students
                </h4>
                <p className="mb-2">Prof.S.M.M.Haq</p>
                <p className="mb-2">
                  <i className="fa fa-phone-alt"></i> +91-9886457844
                </p>
                <p className="mb-2">
                  <i className="fa fa-envelope"></i> info@mcmcollege.com
                </p>
                <p className="mb-2">
                  <i className="fa fa-globe"></i> http://www.mcmcollege.com
                </p>
                <p className="mb-0">Mon-Fri: 8:00 AM - 6:00 PM EST</p>
              </div>
            </div>
          </div>

          <div className="row g-5">
            <div className="col-lg-7 wow fadeInUp" data-wow-delay="0.1s">
              <h3 className="mb-4">Send Us a Message</h3>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-general"
                  role="tabpanel"
                >
                  <form id="contactForm">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="fullName"
                            placeholder="Your Full Name"
                            required
                          />
                          <label for="fullName" className="required-field">
                            Full Name
                          </label>
                          <div className="invalid-feedback">
                            Please enter your full name
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Your Email"
                            required
                          />
                          <label for="email" className="required-field">
                            Email Address
                          </label>
                          <div className="invalid-feedback">
                            Please enter a valid email address
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="tel"
                            className="form-control"
                            id="phone"
                            placeholder="Phone Number"
                          />
                          <label for="phone">Phone Number</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            id="inquiryType"
                            required
                          >
                            <option value="">Select Inquiry Type</option>
                            <option value="general">General Information</option>
                            <option value="campus">Campus Visit</option>
                            <option value="facilities">
                              Facilities & Services
                            </option>
                            <option value="career">Career Services</option>
                            <option value="other">Other</option>
                          </select>
                          <label for="inquiryType" className="required-field">
                            Inquiry Type
                          </label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="subject"
                            placeholder="Subject"
                            required
                          />
                          <label for="subject" className="required-field">
                            Subject
                          </label>
                          <div className="invalid-feedback">
                            Please enter a subject
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <textarea
                            className="form-control"
                            placeholder="Your Message"
                            id="message"
                            style={{ height: "150px" }}
                            required
                          ></textarea>
                          <label for="message" className="required-field">
                            Your Message
                          </label>
                          <div className="invalid-feedback">
                            Please enter your message
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        
                        {/* <div className="form-check mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="privacy"
                            required
                          />
                          {/* <label className="form-check-label" for="privacy">
                            I agree to the{" "}
                            <a href="privacy.html" className="text-primary">
                              Privacy Policy
                            </a>{" "}
                            *
                          </label> */}
                        {/* </div>  */}
                      </div>
                      <div className="col-12">
                        <button
                          className="btn btn-primary py-3 px-5"
                          type="submit"
                          id="submitBtn"
                        >
                          <span id="btnText">Send Message</span>
                          <span id="btnLoading" className="d-none">
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Sending...
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>

                  <div id="successMessage" className="contact-success d-none">
                    <h4>
                      <i className="fas fa-check-circle me-2"></i>Message Sent
                      Successfully!
                    </h4>
                    <p className="mb-0">
                      Thank you for contacting us. We'll get back to you within
                      24 hours.
                    </p>
                  </div>

                  <div id="errorMessage" className="contact-error d-none">
                    <h4>
                      <i className="fas fa-exclamation-circle me-2"></i>Error
                      Sending Message
                    </h4>
                    <p className="mb-0">
                      There was a problem sending your message. Please try again
                      or contact us directly.
                    </p>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-admissions"
                  role="tabpanel"
                >
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    For admissions inquiries, please include your intended
                    program and entry term in your message.
                  </div>
                  <p>
                    Use the form above for admissions inquiries. The admissions
                    team will respond with specific information about
                    requirements, deadlines, and application process.
                  </p>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-international"
                  role="tabpanel"
                >
                  <div className="alert alert-info">
                    <i className="fas fa-globe me-2"></i>
                    For international student inquiries, please include your
                    country of origin and current visa status.
                  </div>
                  <p>
                    Our international office specializes in visa processes,
                    language requirements, and cultural adaptation. Use the form
                    above for detailed assistance.
                  </p>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-academic"
                  role="tabpanel"
                >
                  <div className="alert alert-info">
                    <i className="fas fa-graduation-cap me-2"></i>
                    For academic inquiries, please specify the department and
                    course you're interested in.
                  </div>
                  <p>
                    Academic advisors can provide information about specific
                    programs, curriculum, faculty, and research opportunities.
                    Use the form above to connect with the right department.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-5 wow fadeInUp" data-wow-delay="0.3s">
              <div className="map-container mb-4">
                <iframe
                  className="w-100"
                  style={{ height: "300px", border: "none" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.177858804275!2d-73.98784468459418!3d40.705538979331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a315cdf4c9b%3A0x8b934de5cae6f7a!2sNew%20York%20University!5e0!3m2!1sen!2sus!4v1643561234567!5m2!1sen!2sus"
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>

                <div className="mt-4">
                  <h5 className="mb-3">&nbsp;&nbsp;Connect With Us</h5>
                  <div className="social-contact">
                    &nbsp;&nbsp;
                    <a href="#" title="Facebook">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="#" title="Twitter">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="#" title="Instagram">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" title="LinkedIn">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="#" title="YouTube">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Contact;
